import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

const Specification = ({ specifications, title }) => {
  const selectedSpecification = useSelector((state) => state.specification);

  let specArr;
  if (
    selectedSpecification?.specifications &&
    selectedSpecification.specifications.length > 0
  ) {
    specArr = JSON.parse(selectedSpecification.specifications);
  } else {
    specArr = JSON.parse(specifications);
  }
  if (!specArr) specArr = false;

  const setSelected = (event) => {
    event.currentTarget.classList.toggle('expanded');
  };
  return (
    specArr &&
    specArr.length > 0 && (
      <div className="small-12 large-12 columns product-about">
        <h3 className="product-about__block-title">{title}</h3>
        <div className="product-about__accordion">
          {specArr.map((spec, index) => (
            <div
              className="product-about__heading-container"
              key={index}
              onClick={(e) => setSelected(e)}
            >
              <div className="product-about__heading">
                <h6 className="product-about__title">{spec.heading}</h6>
                <div className="product-about__icon"></div>
              </div>
              <div className="product-about__content">
                <div className=" product-about__documents">
                  {spec.fieldValues &&
                    spec.fieldValues.length > 0 &&
                    spec.fieldValues.map((speces, indexInner) => (
                      speces.key != "Material1Description" &&
                      speces.key != "Material2Description" &&
                      <div
                        key={indexInner}
                        className="product-about__specifications"
                      >
                        <div className="product-about__specifications-item">
                          {speces.translation}
                        </div>
                        <div className="spacer">
                          <div></div>
                        </div>
                        <div className="product-about__specifications-item">
                          {speces.value}
                        </div>
                      </div>
                    ))}
                </div>
                {spec.fieldValues.filter(item =>
                  item.key == "Material1Description"
                  || item.key == "Material2Description").map(item => (
                    item.value &&
                    <Fragment key={item.key}>
                      <h4 className="product-about__description-title">
                        {item.translation}
                      </h4>
                      <p>{item.value}</p>
                    </Fragment>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default Specification;
